/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line
  
  document.addEventListener("DOMContentLoaded", function() {
    // Função para forçar o SwatchKing a ler novamente a página
    function reinitSwatchKing() {
      console.log("SwatchKing: A reinstanciar os botões após atualização do tema.");
      
      if (window.initializeSwatches && typeof window.initializeSwatches === 'function') {
        window.initializeSwatches();
      }
      else if (window.SwatchesKing && typeof window.SwatchesKing.init === 'function') {
        window.SwatchesKing.init();
      }
      else {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      }
    }

    // 1. Escuta quando um produto é adicionado/atualizado pelo Quick View ou Upsell
    document.addEventListener("theme:product:added", function() {
      setTimeout(reinitSwatchKing, 100); 
    });

    // 2. Escuta quando o modal/gaveta do carrinho abre
    document.addEventListener("theme:cart-drawer:open", function() {
      setTimeout(reinitSwatchKing, 150);
    });
  });

})();